import { styled } from '@linaria/react';
export const GridLayoutWrapper = styled.div`
	.loader {
		min-height: 85vh;
	}
`;
